import Illustration from "components/illustration";

const Forbidden = () => {
  return <Illustration illustration="forbidden" text="General.forbidden" />;
};

export default Forbidden;
